import React from 'react';
import Lottie from 'react-lottie';
import whiteAnimation from '../../lottie/konsol.json';
import greenAnimation from '../../lottie/konsol_green.json';
import './logo.css'
import { useTheme, useMediaQuery, } from '@mui/material';



export default function KonsolLogo(props) {
    const {
        isLoading,
        width = '150px',
        height = '38px',
    } = props

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))
    const isLg = useMediaQuery(theme.breakpoints.down('xl'))

    const whiteOptions = {
        loop: true,
        autoplay: true,
        animationData: whiteAnimation,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };
    const greenOptions = {
        loop: true,
        autoplay: true,
        animationData: greenAnimation,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };

    // Responsive styling
    //   If Xs, shrink Konsol logo significantly
    //   Otherwise regular size

    return (
    <div id='KonsolLogo' style={{ position: 'relative', width: width, height: isXs?'20px':height }}>
        <Lottie
            id='greenlogo'
            width={isXs ? 80 : width}
            options={greenOptions}
            speed={isLoading ? 4 : 0.25 }
            style={{ position: 'absolute', top: 0, left: 0 }} />
        <Lottie
            id='whitelogo'
            width={isXs ? 80 : width}
            height={isXs ? 20 : ''}
            options={whiteOptions}
            speed={isLoading ? 4 : 0.25 }
            style={{ position: 'absolute', top: 0, left: 0, animation: isLoading ? 'fadeOut 0.5s forwards' : 'fadeIn 0.5s forwards' }} />
    </div>
);
}